import { render, staticRenderFns } from "./driversAccounts.vue?vue&type=template&id=f154f83e&scoped=true&"
import script from "./driversAccounts.vue?vue&type=script&lang=js&"
export * from "./driversAccounts.vue?vue&type=script&lang=js&"
import style0 from "./driversAccounts.vue?vue&type=style&index=0&id=f154f83e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f154f83e",
  null
  
)

export default component.exports